import { jsx as _jsx } from "react/jsx-runtime";
import { TableCell, Tooltip } from '@mui/material';
const NotesColumn = ({ notes, testId }) => {
    return (_jsx(TableCell, { "data-testid": testId ? testId : '', className: "truncate-notes-cell", children: notes ? (_jsx(Tooltip, { title: notes, arrow: true, placement: "top", children: _jsx("span", { children: notes }) })) : (_jsx("small", { children: "-" })) }));
};
export default NotesColumn;
